/* tslint:disable */
/* eslint-disable */
/**
 * File API
 * API for managing files
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Types de contexte
 * @export
 */
export const ContextEnum = {
    Person: 0,
    HomeTenant: 1,
    LoanProject: 2,
    Quote: 3
} as const;
export type ContextEnum = typeof ContextEnum[keyof typeof ContextEnum];


export function instanceOfContextEnum(value: any): boolean {
    for (const key in ContextEnum) {
        if (Object.prototype.hasOwnProperty.call(ContextEnum, key)) {
            if (ContextEnum[key as keyof typeof ContextEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ContextEnumFromJSON(json: any): ContextEnum {
    return ContextEnumFromJSONTyped(json, false);
}

export function ContextEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContextEnum {
    return json as ContextEnum;
}

export function ContextEnumToJSON(value?: ContextEnum | null): any {
    return value as any;
}

export function ContextEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ContextEnum {
    return value as ContextEnum;
}

